// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  Analytics,
  getAnalytics,
  isSupported,
  logEvent,
} from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB5fcmyYgtTZHpZErYhUqmTtvDSMco9h0w",
  authDomain: "ionic-firebase-31647.firebaseapp.com",
  projectId: "ionic-firebase-31647",
  storageBucket: "ionic-firebase-31647.firebasestorage.app",
  messagingSenderId: "862833967447",
  appId: "1:862833967447:web:aa870d383358387067be12",
  measurementId: "G-0WQW1K0HEC",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Telegram's embedded browsers don't all satisfy Analytics' prerequisites
// (IndexedDB, cookies) — isSupported() checks before getAnalytics() ever
// runs, so an unsupported webview can't throw during app startup.
let analyticsPromise: Promise<Analytics | null> | null = null;
const getAnalyticsInstance = () => {
  if (!analyticsPromise) {
    analyticsPromise = isSupported()
      .then((supported) => (supported ? getAnalytics(app) : null))
      .catch(() => null);
  }
  return analyticsPromise;
};

export type FirebasePurchaseItem = {
  item_id: string;
  item_name: string;
  price: number;
  quantity: number;
};

// This app's order backend is production — analytics must never be able to
// affect the checkout flow it's reporting on. Every failure mode here (SDK
// unsupported, network blocked, bad input) is swallowed, never thrown, and
// the caller doesn't need to await this to keep checkout responsive.
export type FirebasePurchase = {
  // GA4 standard ecommerce params — reported without registering anything.
  transaction_id: string;
  value: number;
  currency?: string;
  shipping?: number;
  affiliation?: string;
  coupon?: string;
  items: FirebasePurchaseItem[];
  // Custom params — each one needs a matching custom dimension/metric in GA4
  // before it shows up in any report beyond DebugView.
  order_id?: number;
  event_id?: string;
  content_ids?: string;
  content_name?: string;
  content_type?: string;
  delivery_type?: string;
  delivery_cost?: number;
  bonus_pay?: number;
  payment_id?: string;
  payment_type?: string;
  card_id?: number;
  num_items?: number;
  items_count?: number;
  source?: string;
};

export const logPurchase = async (purchase: FirebasePurchase) => {
  try {
    const analytics = await getAnalyticsInstance();
    if (!analytics) return;

    logEvent(analytics, "purchase", {
      ...purchase,
      currency: purchase.currency ?? "UZS",
    });
  } catch (error) {
    console.error("[firebase] failed to log purchase event", error);
  }
};
